import { HelmUpgradeCommandBuilder } from "~/utils/HelmCommands/HelmUpgradeCommandBuilder";

export class KubernetesAgentInstallationCommandBuilder extends HelmUpgradeCommandBuilder {
    constructor(version: string, namespace: string, releaseName: string, registryUrl: string, lineBreakCharacter: string) {
        super(version, namespace, releaseName, registryUrl, lineBreakCharacter);

        this.withValue("agent.acceptEula", "Y");
    }

    public withCommonHelmSetValues(spaceName: string, serverUrl: string, serverCommsAddress: string, bearerToken: string): KubernetesAgentInstallationCommandBuilder {
        return this.withValue("agent.space", spaceName).withValue("agent.serverUrl", serverUrl).withValue("agent.serverCommsAddresses", `{${serverCommsAddress}}`).withValue("agent.bearerToken", bearerToken);
    }
}
